import React from 'react';
import { Card, CardHeader, Row, Col, Container } from 'reactstrap';
import BranchTreatment from './BranchTreatment';
import TableCalendarGrid from './TableCalendarGrid';
import { H3 } from 'AbstractElements';
import { useSelector } from 'react-redux';
import 'moment/locale/id';

const groupSchedulesByDate = (schedules) => {
    const grouped = {};
    schedules.forEach((item) => {
        if (!grouped[item.schedule_date]) {
            grouped[item.schedule_date] = [];
        }
        grouped[item.schedule_date].push(item);
    });

    // Sort each group by id in ascending order
    Object.keys(grouped).forEach((date) => {
        grouped[date].sort((a, b) => a.id - b.id);
    });

    return grouped;
};

const ScheduleList = ({ schedules }) => { 
    const currentBranch = useSelector((state) => state.branch.currentBranch);
    const groupedSchedules = groupSchedulesByDate(schedules);


    return (
        <Container fluid={true}>
            <Card>
                <CardHeader className="pb-3 text-center">
                    <H3>Daftar Pengaturan Jadwal di {currentBranch?.name}</H3>
                </CardHeader>
                <Col sm="12" lg="12" xl="12">
                    <TableCalendarGrid groupedSchedules={groupedSchedules} />
                </Col>
            </Card>
        </Container>
        
    );
};

export default ScheduleList;
